export default __webpack_public_path__ + "static/media/play-v1-white.34843b13.png";